import {useEffect} from 'react';

// This hook will once after the component is mounted
export function useMountEffect(effect) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(effect, []);
}
